import { ApolloClient } from '@apollo/client';

import type { InteractiveLessonSectionFragment } from '../lesson-builder.graphql.generated';
import { SectionOrSubSection } from '../activity-builder.constants';
import { interactiveLessonSectionFragment } from '../lesson-builder.graphql';
import { findActivity } from '../components/activity/activity.utils';
import { LANGUAGE_CODE_EN_AU } from 'global/constants';
import type { Pluck } from 'lib/gql/pluck';

export function findActivityFromSectionOrSubSection(
  client: ApolloClient<any>,
  section?: SectionOrSubSection
) {
  let targetSection: InteractiveLessonSectionFragment | undefined;
  if (section && 'parentSectionId' in section) {
    const parentSectionId = (
      section as Pluck<InteractiveLessonSectionFragment, 'subSections'>
    ).parentSectionId;
    if (parentSectionId) {
      targetSection =
        client.readFragment<InteractiveLessonSectionFragment>({
          id: client.cache.identify({
            __typename: 'ActivitiesSection',
            id: parentSectionId,
            language: LANGUAGE_CODE_EN_AU,
          }),
          fragment: interactiveLessonSectionFragment,
          fragmentName: 'InteractiveLessonSectionFragment',
        }) || undefined;
    }
  } else {
    targetSection = section;
  }
  return findActivity(targetSection);
}
